module.exports = __webpack_public_path__ + "ec259ae5e533e1431de293b22869d977.png";